import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { allEquipmentsListKey } from '@pages/ManageTemplate/services/useAllEquipmentsListQuery';

import { apiClient } from '@services/apiClient';

import { equipmentsListKey } from './useEquipmentsListInfiniteQuery';
import { equipmentsLogListKey } from './useEquipmentsLogListInfiniteQuery';

const equipmentUpdateFn = (data: {
  id: number;
  asset_code: string;
  location_id: number;
  name: string;
  equipment_type_id: number;
}) => apiClient.post(`${APP_API_URL}equipment/update`, data);

export const useEquipmentUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentUpdateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [allEquipmentsListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [equipmentsListKey({})[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentsLogListKey({})[0]] });
      }, timeoutDelay);
    },
  });
};
